import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import ProtectedRoute from './components/admin/ProtectedRoute';

// Initialize Google Analytics
ReactGA.initialize('G-CMCM8C2JSW');

// Component to track page views automatically
const AnalyticsTracker = () => {
    const location = useLocation();

    useEffect(() => {
        ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
    }, [location]);

    return null;
};

// Lazy load admin components to optimize initial bundle size
const LoginPage = React.lazy(() => import('./components/admin/LoginPage'));
const AdminDashboard = React.lazy(() => import('./components/admin/AdminDashboard'));

// Landing Page Component
const LandingPage = () => {
    const [activeTab, setActiveTab] = useState('Society');
    const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);

    const scrollToContact = () => {
        const contactSection = document.getElementById('contact');
        if (contactSection) {
            contactSection.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="font-sans text-darkText bg-bgLight flex flex-col min-h-screen">
            <Header
                scrollToContact={scrollToContact}
            />

            <main className="flex-grow">
                <Hero
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    scrollToContact={scrollToContact}
                />
                <About />
                <Services />
                <ContactForm
                    role={activeTab}
                    setRole={setActiveTab}
                />
            </main>

            <Footer openPrivacy={() => setIsPrivacyOpen(true)} />
            <PrivacyPolicy isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} />
        </div>
    );
};

function App() {
    return (
        <Router>
            <AnalyticsTracker />
            <React.Suspense fallback={<div className="min-h-screen bg-bgLight flex items-center justify-center"><div className="w-10 h-10 border-4 border-primary/20 border-t-primary rounded-full animate-spin" /></div>}>
                <Routes>
                    {/* Public Landing Page */}
                    <Route path="/" element={<LandingPage />} />
    
                    {/* Admin Routes */}
                    <Route path="/admin/login" element={<LoginPage />} />
                    <Route
                        path="/admin/dashboard"
                        element={
                            <ProtectedRoute>
                                <AdminDashboard />
                            </ProtectedRoute>
                        }
                    />
    
                    {/* Catch all - Redirect to home */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </React.Suspense>
        </Router>
    );
}

export default App;
